import { render, staticRenderFns } from "./pay2.vue?vue&type=template&id=75196bfe&scoped=true"
import script from "./pay2.vue?vue&type=script&lang=js"
export * from "./pay2.vue?vue&type=script&lang=js"
import style0 from "./pay2.vue?vue&type=style&index=0&id=75196bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75196bfe",
  null
  
)

export default component.exports